import React from "react";
import Countdown from "./Countdown";
import { ArrowRight } from "@phosphor-icons/react";

const MENTOR_IMG = "/mentor-vishnu.webp";

export default function Hero() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden pt-36 lg:pt-40 pb-16 lg:pb-24 grain"
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 relative">
        {/* LEFT */}
        <div className="lg:col-span-7 anim-fade-up">
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#4A4A4A] border border-[#D4D0C5] px-2 py-1">
              Cohort 15 / 2026
            </span>
            <span className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E]">
              ● Enrolling Now
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display font-black tracking-tighter text-[#0A0A0A] leading-[0.92] text-5xl sm:text-6xl lg:text-[88px]"
          >
            DECODE
            <br />
            THE <span className="text-[#D9381E]">AUCTION.</span>
            <br />
            TRADE THE
            <br />
            <span className="relative inline-block">
              <span className="relative z-10">PARTICIPATION.</span>
              <span className="absolute left-0 right-0 bottom-1 h-3 bg-[#D9381E]/20 -z-0" />
            </span>
          </h1>

          <p className="font-body text-base md:text-lg text-[#4A4A4A] mt-7 max-w-xl">
            A 6-month, institutional-grade program on{" "}
            <span className="font-semibold text-[#0A0A0A]">Market Profile</span>{" "}
            and{" "}
            <span className="font-semibold text-[#0A0A0A]">Order Flow</span>,
            taught by working professionals. Built for traders who refuse to
            guess.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-5">
            <button
              data-testid="hero-cta-enroll"
              onClick={() => scrollTo("enroll")}
              className="group inline-flex items-center justify-center gap-3 bg-[#0A0A0A] text-[#F4F3ED] px-7 py-4 font-body text-sm uppercase tracking-[0.22em] hover-brutal hover-brutal-signal"
            >
              Reserve a seat
              <ArrowRight
                weight="bold"
                className="text-[#D9381E] group-hover:translate-x-1 transition-transform"
              />
            </button>
            <button
              data-testid="hero-cta-syllabus"
              onClick={() => scrollTo("syllabus")}
              className="inline-flex items-center justify-center gap-2 border border-[#0A0A0A] text-[#0A0A0A] px-7 py-4 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#0A0A0A] hover:text-[#F4F3ED] transition-colors"
            >
              View Syllabus
            </button>
          </div>

          <div className="mt-10">
            <Countdown />
          </div>
        </div>

        {/* RIGHT */}
        <div className="lg:col-span-5 relative">
          <div className="relative border border-[#0A0A0A] bg-[#EAE8DF] anim-fade-up">
            <div className="flex items-center justify-between px-3 py-2 border-b border-[#0A0A0A]/80 bg-[#F4F3ED]">
              <span className="font-mono-acc text-[10px] tracking-[0.25em] uppercase">
                MENTOR.PROFILE
              </span>
              <span className="font-mono-acc text-[10px] tracking-[0.25em] text-[#D9381E]">
                ● LIVE
              </span>
            </div>

            <div className="relative">
              <img
                src={MENTOR_IMG}
                alt="Vishnu Gupthan R"
                className="w-full aspect-[4/5] object-cover"
                loading="eager"
              />
              <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0A0A0A]/60 to-transparent pointer-events-none" />
              <div className="absolute left-3 bottom-3 right-3 flex items-end justify-between">
                <div>
                  <div className="font-mono-acc text-[10px] tracking-[0.25em] text-[#F4F3ED]/80">
                    LEAD INSTRUCTOR
                  </div>
                  <div className="font-display font-black text-2xl text-[#F4F3ED] leading-tight">
                    VISHNU GUPTHAN R
                  </div>
                </div>
                <span className="font-mono-acc text-[10px] text-[#D9381E] border border-[#D9381E] px-2 py-1">
                  20+ YRS
                </span>
              </div>
            </div>

            <div className="grid grid-cols-3 border-t border-[#0A0A0A]/80 divide-x divide-[#0A0A0A]/80 text-center">
              <div className="px-2 py-3">
                <div className="font-mono-acc font-bold text-lg">20+</div>
                <div className="font-mono-acc text-[9px] tracking-[0.2em] uppercase text-[#4A4A4A]">
                  Yrs Market
                </div>
              </div>
              <div className="px-2 py-3">
                <div className="font-mono-acc font-bold text-lg">500+</div>
                <div className="font-mono-acc text-[9px] tracking-[0.2em] uppercase text-[#4A4A4A]">
                  Students
                </div>
              </div>
              <div className="px-2 py-3">
                <div className="font-mono-acc font-bold text-lg">10+</div>
                <div className="font-mono-acc text-[9px] tracking-[0.2em] uppercase text-[#4A4A4A]">
                  Yrs MP & OF
                </div>
              </div>
            </div>
          </div>

          {/* Floating ticker badge */}
          <div className="hidden md:block absolute -left-8 top-6 bg-[#0A0A0A] text-[#F4F3ED] px-4 py-3 border border-[#0A0A0A] shadow-[6px_6px_0_#D9381E]">
            <div className="font-mono-acc text-[9px] tracking-[0.3em] text-[#A1A1AA]">
              VALUE.AREA.HIGH
            </div>
            <div className="font-mono-acc font-bold text-lg leading-none">
              24,318.25
            </div>
          </div>
          <div className="hidden md:block absolute -right-6 bottom-10 bg-[#F4F3ED] border border-[#0A0A0A] px-4 py-3 shadow-[6px_6px_0_#0A0A0A]">
            <div className="font-mono-acc text-[9px] tracking-[0.3em] text-[#4A4A4A]">
              CVD.DELTA
            </div>
            <div className="font-mono-acc font-bold text-lg leading-none text-[#D9381E]">
              +12,847
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
